import { Box, Button, TextField } from "@mui/material";
import { SubscriptionHeaderBox } from "./styles";
import { SubscriptionHeader, TopContainer, styles } from "./styles";
import { useContext, useState } from "react";
import { AuthContext, UserDetailsContext } from "../../contexts";
import { tierMap } from "./types";
import PageLayout from "../../components/PageLayout/PageLayout";
import { SubscriptionPlans } from "../../components/SubscriptionPlans/SubscriptionPlans";
import StorageComponent from "../../components/StorageComponent/StorageComponent";
import { useGetCustomerPortalLink } from "../../hooks/useGetCustomerPortalLink";
import { submitPromoCode } from "../../services/promoCodeService";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { PostPromotionCodeResponse } from "../../proto/api_pb";
import { toast } from "react-toastify";
import { RpcError, StatusCode } from "grpc-web";

export const Billing = (): JSX.Element => {
  const [promoCode, setPromoCode] = useState<string>("");
  const { subscriptionTier, userName, fullName } =
    useContext(UserDetailsContext);
  const { userId } = useContext(AuthContext);
  const { getValidAccessToken } = useGetValidAccessToken();
  const { getCustomerPortalLink } = useGetCustomerPortalLink();

  const handleSubmitPromotionCode = async () => {
    const accessToken = await getValidAccessToken();
    const response = await submitPromoCode(accessToken, userId, promoCode);
    if (response instanceof PostPromotionCodeResponse) {
      console.log(response);
      toast.success("Promo code applied successfully");
    } else if (response instanceof RpcError) {
      if (response?.code === StatusCode.NOT_FOUND) {
        toast.error("Promo code not found");
      } else if (response?.code === StatusCode.INVALID_ARGUMENT) {
        toast.error("Error applying promo code");
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <>
      <PageLayout>
        <SubscriptionHeader>
          {fullName} (@{userName}), you are subscribed to OmMuse{" "}
          {tierMap[subscriptionTier]}
        </SubscriptionHeader>
        <Box sx={styles.billingPageContainer}>
          <Box sx={styles.paymentComponentContainer}>
            <Box>
              <TopContainer>
                <SubscriptionHeaderBox>
                  <Button
                    onClick={getCustomerPortalLink}
                    variant="contained"
                    sx={styles.billingButton}
                  >
                    Change Plan
                  </Button>
                  <Button
                    variant="contained"
                    onClick={getCustomerPortalLink}
                    sx={styles.billingButton}
                  >
                    Update Payment Method
                  </Button>
                  <Button
                    variant="contained"
                    onClick={getCustomerPortalLink}
                    sx={styles.billingButton}
                  >
                    Billing History
                  </Button>
                  <TextField
                    sx={styles.promoCodeInput}
                    placeholder="Apply Promo"
                    onChange={(e) => setPromoCode(e.target.value)}
                    id="outlined-basic"
                    variant="outlined"
                  />
                  <Button
                    onClick={handleSubmitPromotionCode}
                    variant="contained"
                    sx={styles.submitButton}
                  >
                    Apply
                  </Button>
                  <Box sx={{ display: "flex", alignItems: "center " }}></Box>
                </SubscriptionHeaderBox>
                <StorageComponent />
              </TopContainer>
              <hr />
              <SubscriptionPlans />
            </Box>
          </Box>
        </Box>
      </PageLayout>
    </>
  );
};
